//css
import styles from './Footer.module.css'



const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p>Desenvolvido Por Dian Novais - Todos direitos reservados |</p>
      <p> DitecBlog &copy; 2022</p>
    </footer>
  )
}

export default Footer